import { t } from '../theme';
import { useStore } from '../store';

/**
 * The paired phone, once the QR modal has done its job and closed.
 *
 * Everything the modal was still carrying after pairing — that the phone is
 * connected, how much it has put away, and the way to unpair — condensed into
 * a strip that does not sit on top of the fridge you are trying to watch.
 */
export function PhoneLinkBar() {
  const link = useStore((s) => s.phoneLink);
  const unpair = useStore((s) => s.unpairPhone);
  if (!link) return null;

  return (
    <div
      style={{
        position: 'absolute',
        left: '50%',
        bottom: 18,
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        padding: '10px 12px 10px 20px',
        borderRadius: 999,
        background: 'oklch(0.24 0.012 60 / 0.92)',
        backdropFilter: 'blur(14px)',
        border: `1px solid ${t.accent}`,
        boxShadow: '0 18px 40px -22px oklch(0.05 0 0 / 0.9)',
        zIndex: 30,
        animation: 'rise 220ms ease-out',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div
          style={{
            width: 9,
            height: 9,
            borderRadius: 999,
            background: t.accent,
            animation: 'halo 2.4s ease-out infinite',
          }}
        />
        <span style={{ fontSize: 18, fontWeight: 500, whiteSpace: 'nowrap' }}>Handy verbunden</span>
      </div>
      <span style={{ fontFamily: t.mono, fontSize: 14, color: t.inkFaint, whiteSpace: 'nowrap' }}>
        {link.itemCount} eingeräumt
      </span>
      <div
        className="press"
        onClick={() => void unpair()}
        style={{
          height: 40,
          padding: '0 16px',
          borderRadius: 999,
          background: t.control,
          display: 'flex',
          alignItems: 'center',
          fontSize: 16,
          fontWeight: 500,
          whiteSpace: 'nowrap',
        }}
      >
        Trennen
      </div>
    </div>
  );
}
